<template>
  <v-container fluid class="fill-height">
	  <v-btn class="p-absolute ml-3 white--text" style="top: 98px; z-index: 4;" color="#2BC1B6"
	         @click="gerarPdfListaAbate" :loading="loadingListaAbate">
		  Lista de Abate
	  </v-btn>
    <v-row v-if="mustReallocate" class="ma-0">
      <v-spacer />
      <reallocate-lots-dialog>
        <template v-slot:activator="on">
          <v-btn
            v-on="on"
            color="#10303d"
            class="white--text reallocate-batches-btn"
          >
            Atualizar saldo
          </v-btn>
        </template>
      </reallocate-lots-dialog>
    </v-row>
    <GridViewPlantsWithDates>
      <CardItemPlantaAbateLotes @animaisChanged="animaisChanged" />
      <DialogConfirmarAlteracoes
        :dialog="dialogConfirmarLotes"
        @cancelarConfirmacao="closeDialogConfirmar"
        @sendConfirmarLotes="sendConfirmarLotes"
        window="lotes"
        :heightTotal="290"
      />
    </GridViewPlantsWithDates>
    <v-row class="ma-3 total-float-lotes elevation-1" v-if="!dialogBathsAvaliable">
      <v-col cols="2">
        <span class="total-demand__text">Demanda total</span>
        <br />
        <v-autocomplete
          class="mt-2"
          v-model="cdPlantaAbate"
          :items="plantasAbate"
          dense
          color="primary"
          item-text="displayName"
          item-value="idPlantaAbate"
          label="Planta de abate"
          outlined
          hide-details
        ></v-autocomplete>
      </v-col>
      <v-col v-for="(item, i) in listBatchAllocatedByPlant" :key="i" class="pa-0 p-relative">
        <v-divider vertical class="p-absolute" />
        <v-row align="center" justify="center" class="ma-0 pa-3 fill-height">
          <div class="div-dias-semana">
            <span class="text-datas-number ml-12">{{ item.qtTotalAlocado }}</span>
            <span class="text-datas-extenso ml-1 mr-1">de</span>
            <span class="text-datas-number mr-12">
              {{
              item.qtTotalDemanda
              }}
            </span>
            <br />
            <span class="total-demand__value text-capitalize">{{ item.textTotal }}</span>
          </div>
        </v-row>
      </v-col>
      <v-divider vertical />
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";

import GridViewPlantsWithDates from "../components/GridViewPlantsWithDates.vue";
import CardItemPlantaAbateLotes from "../components/CardItemPlantaAbateLotes.vue";
import DialogConfirmarAlteracoes from "../components/DialogConfirmarAlteracoes.vue";
import services from "@/http/services";
import ReallocateLotsDialog from "@/modules/programacaoAbate/components/ReallocateLotsDialog";
import { SlaughterProgrammingStepsEventBus } from "@/modules/programacaoAbate/events";

export default {
  name: "Lotes",
  components: {
    GridViewPlantsWithDates,
    CardItemPlantaAbateLotes,
    DialogConfirmarAlteracoes,
    ReallocateLotsDialog,
  },
  props: {
    confirmarLotes: {
      type: Boolean,
      default: false,
    },
    salvarLotes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogConfirmarLotes: false,
      cdPlantaAbate: 0,
      listPlantasAbateAlocadas: [],
	    loadingListaAbate: false,
    };
  },
  created() {
    this.ActionSetExtensionistas(this.extensionistas);
    this.ActionSetTipoGenero(this.tiposGenero);
    this.ActionLoadBatchsAllocated(
      this.programacaoAbateSelected.idProgramacaoAbate
    );
    this.cdPlantaAbate = this.plantasAbate[
      this.plantasAbate.length - 1
    ].idPlantaAbate;
  },
  computed: {
    ...mapState(["extensionistas", "tiposGenero", "plantasAbate"]),
    ...mapState("programacaoAbate", [
      "programacaoAbateSelected",
      "listBatchsAllocated",
      "listBatchsAllocatedToRemove",
      "listaDemandasPlanta",
      "listDatesWithDemand",
      "dialogBathsAvaliable",
    ]),
    mustReallocate() {
      let mustReallocate = false;
      this.listBatchsAllocated.forEach((item) => {
        if (item["blBaixa"] || item["blGta"]) mustReallocate = true;
      });
      return mustReallocate;
    },
    totalDemands() {
      const totalDemands = this.listaDemandasPlanta.reduce((acc, curr) => {
        this.listDatesWithDemand.forEach((item) => {
          if (!acc) acc = {};
          if (!acc[item.value])
            acc[item.value] = parseInt(curr[item.value] || 0);
          else acc[item.value] += parseInt(curr[item.value] || 0);
        });
        return acc;
      }, {});
      return totalDemands || {};
    },
    listBatchAllocatedByPlant() {
      let listPlantasAbateAlocadas = [];
      let listDemandFiltered = this.listaDemandasPlanta.filter(
        (x) => x.cdPlantaAbate == this.cdPlantaAbate
      );
      let listBatchsAllocatedFiltered = this.listBatchsAllocated.filter(
        (x) => x.cdPlantaAbate == this.cdPlantaAbate && !x.blDeleted
      );

      this.listDatesWithDemand.forEach((itemData) => {
        let itemDemand = listDemandFiltered[0][itemData.value];
        if (itemDemand) {
          let listAlocadosFiltradaDia = listBatchsAllocatedFiltered.filter(
            (x) => x.stDiaAlocado == itemData.value
          );

          if (listAlocadosFiltradaDia) {
            let totalAlocadoDia = 0;
            listAlocadosFiltradaDia.forEach((item) => {
              totalAlocadoDia =
                totalAlocadoDia + parseInt(item.qtAnimaisAlocados);
            });

            let textTotal = "";
            let diff = parseInt(itemDemand) - parseInt(totalAlocadoDia);
            if (diff < 0) {
              textTotal = "Sobrando " + Math.abs(diff);
            } else if (diff === 0) {
              textTotal = "Demanda completa";
            } else {
              textTotal = "Faltam " + Math.abs(diff);
            }

            let rec = {
              dayText: itemData.dayText,
              semanaText: itemData.semanaText,
              text: itemData.text,
              value: itemData.value,
              qtTotalDemanda: itemDemand,
              qtTotalAlocado: totalAlocadoDia,
              textTotal: textTotal,
            };

            listPlantasAbateAlocadas.push(rec);
          }
        } else {
          let rec = {
            dayText: itemData.dayText,
            semanaText: itemData.semanaText,
            text: itemData.text,
            value: itemData.value,
            qtTotalDemanda: 0,
            qtTotalAlocado: 0,
            textTotal: "Sem demanda",
          };

          listPlantasAbateAlocadas.push(rec);
        }
      });
      return listPlantasAbateAlocadas
    },
	  urlAPI() {
		  return this.$store.state.urlAPI
	  },
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionConfirmarLotes",
      "ActionLoadBatchsAllocated",
      "ActionLoadProgramacaoAbate",
      "ActionSetExtensionistas",
      "ActionSetTipoGenero",
      "ActionRemoveAllocatedLots",
      "ActionBatchUpdateProgramacaoAbateAlocado",
    ]),
    openConfirmarLotes(value) {
      this.dialogConfirmarLotes = value;
    },
    closeDialogConfirmar() {
      this.dialogConfirmarLotes = false;
      this.$emit("cancelConfirmarLotes");
    },
    sendConfirmarLotes() {
      const updatePayload = this.listBatchsAllocated.filter(
        (item) => item.blChanged
      );
      let deletePayload = this.listBatchsAllocated.filter(
        (item) => item["blDeleted"]
      );
      deletePayload = deletePayload.map(
        (item) => item.idProgramacaoAbateAlocado
      );
      const updateBatchPromise = this.ActionBatchUpdateProgramacaoAbateAlocado(
        updatePayload
      );

      const deletePromise =
        deletePayload.length && deletePayload.length > 0
          ? this.ActionRemoveAllocatedLots(deletePayload)
          : Promise.resolve();

      return Promise.all([updateBatchPromise, deletePromise]).then(() => {
        return this.ActionConfirmarLotes({ status: 3, notificarProdutor: true }).finally(() => {
          this.ActionLoadBatchsAllocated(
            this.programacaoAbateSelected.idProgramacaoAbate
          )
          this.ActionLoadProgramacaoAbate(
            this.programacaoAbateSelected.idProgramacaoAbate
          ).then(() => {
            SlaughterProgrammingStepsEventBus.$emit("set-step", 3)
          })
          this.closeDialogConfirmar()
        })
      })
    },
    sendSalvarLotes() {
      const updatePayload = this.listBatchsAllocated.filter(
        (item) => item.blChanged
      );
      let deletePayload = this.listBatchsAllocated.filter(
        (item) => item["blDeleted"]
      );
      deletePayload = deletePayload.map(
        (item) => item.idProgramacaoAbateAlocado
      );
      const updateBatchPromise = this.ActionBatchUpdateProgramacaoAbateAlocado(
        updatePayload
      );

      const deletePromise =
        deletePayload.length && deletePayload.length > 0
          ? this.ActionRemoveAllocatedLots(deletePayload)
          : Promise.resolve();

      return Promise.all([updateBatchPromise, deletePromise])
        .then(() => {
          this.$store.commit("setSnack", {
            type: "success",
            msg: "Rascunho salvo com sucesso.",
          });
        })
        .finally(() => {
          this.ActionLoadBatchsAllocated(
            this.programacaoAbateSelected.idProgramacaoAbate
          )
        })
    },
    canConfirmWithRaise() {
      let valid = true;

      // this.listBatchsAllocated.forEach((loteAlocado) => {
      //   console.log(loteAlocado)
      //   if (
      //     (loteAlocado.qtAnimaisAlocados === null ||
      //       loteAlocado.qtAnimaisAlocados === undefined ||
      //       loteAlocado.qtAnimaisAlocados === "" ||
      //       loteAlocado.qtAnimaisAlocados === 0 ||
      //       loteAlocado.qtAnimaisAlocados === "0") &&
      //     !loteAlocado.blDeleted
      //   )
      //     valid = false;
      // });
      //
      // if (!valid) {
      //   this.$store.commit("setSnack", {
      //     type: "error",
      //     msg: "Alguns lotes não foram preenchidos",
      //   });
      //   return false;
      // }

      const allocatedByLot = this.listBatchsAllocated.reduce(
        (acc, loteAlocado) => {
          if (!acc[loteAlocado.cdLoteProducao])
            acc[loteAlocado.cdLoteProducao] = 0;
          if (!loteAlocado.blDeleted) {
            acc[loteAlocado.cdLoteProducao] +=
              parseInt(loteAlocado.qtAnimaisAlocados) || 0;
          }
          return acc;
        },
        {}
      );

      const availableByLot = this.listBatchsAllocated.reduce(
        (acc, loteAlocado) => {
          if (!acc[loteAlocado.cdLoteProducao])
            acc[loteAlocado.cdLoteProducao] = 0;
          acc[loteAlocado.cdLoteProducao] +=
            (parseInt(loteAlocado.qtSaldoReal) || 0) -
            (parseInt(allocatedByLot[loteAlocado.cdLoteProducao]) || 0) -
            (parseInt(loteAlocado.loteProducao.qtAnimaisProgramadoAbate) || 0);
          return acc;
        },
        {}
      );

      Object.values(availableByLot).forEach((value) => {
        if (value < 0) valid = false;
      });

      if (!valid) {
        this.$store.commit("setSnack", {
          type: "error",
          msg:
            "Alguns lotes estão com a quantidade de animais alocados acima do disponível",
        });
        return false;
      }

      return valid;
    },
    chanegPlantaAateSelected(cdPlantaAbate) {
    
    },
    animaisChanged() {
      this.chanegPlantaAateSelected(this.cdPlantaAbate);
    },
	  gerarPdfListaAbate() {
    	this.loadingListaAbate = true
      const idProgramacaoAbate = this.programacaoAbateSelected.idProgramacaoAbate
      this.$axios.get(`programacao-abate/${idProgramacaoAbate}/lista-abate/`, {
        responseType: "blob"
      })
		      .then((res) => {
			      let blob = new Blob([res.data], {type: 'application/octet-stream'})
			      let a = document.createElement('a');
			      a.href = URL.createObjectURL(blob)
			      a.download = `lista_abate-${this.programacaoAbateSelected.nrProgramacaoAbate}.pdf`;
			      document.body.appendChild(a);
			      a.click();
			      a.remove();
		      })
		      .finally(() => this.loadingListaAbate = false)
	  },
  },
  watch: {
    confirmarLotes(newValue, oldValue) {
      if (!this.canConfirmWithRaise()) {
        this.$emit("update:confirmarLotes", false);
      } else {
        this.openConfirmarLotes(newValue);
      }
    },
    salvarLotes(newValue) {
      if (!newValue) return;

      this.sendSalvarLotes().finally(() => {
        this.$emit("update:salvarLotes", false);
      });
    },
    cdPlantaAbate(newValue, oldValue) {
      if (newValue != oldValue) {
        this.chanegPlantaAateSelected(newValue);
      }
    },
    listBatchsAllocated(newValue, oldValue) {
      this.chanegPlantaAateSelected(this.cdPlantaAbate);
    },
  },
};
</script>

<style scoped lang="scss">
.total-float-lotes {
  width: 100%;
  left: 0;
  position: sticky;
  bottom: 20px;
  background: white;
  z-index: 5 !important;
}

.total-float__row {
  background: white;
}

.total-float-lotes__row {
  background: white;
  border: 1px solid #f3f3f3;
  border-radius: 5px;
}

.total-demand__text {
  font: bold 16px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565c;
}

.total-demand__value {
  font: bold 16px Roboto;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #37565c;
}

.reallocate-batches-btn {
  width: 200px !important;
}
</style>
